import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import { KatexText } from "./katex-text.js";
import { QuizMedia } from "./quiz-media.js";
import { QuizTypeBadge } from "./quiz-type-badge.js";
import { parsePolygonTitle, PolygonRenderer } from "./polygon-renderer.js";
import { useQuizStyleVariant } from "./quiz-style-context.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
function QuizHeader({
  quizId,
  typeLabel,
  title,
  difficultyLevel,
  variant = "adult",
  image,
  imageMobile,
  desmos,
  vars,
  problem,
  dimTitleText = false,
  dimProblemText = false,
  dimMedia = false
}) {
  const styleVariant = useQuizStyleVariant();
  const isLcStudent = styleVariant === "lc" && variant === "student";
  const isAiqStudent = styleVariant === "aiq" && variant === "student";
  return /* @__PURE__ */ jsxs(
    motion.div,
    {
      "data-quiz-header": true,
      initial: { opacity: 0, y: -10 },
      animate: { opacity: 1, y: 0 },
      className: cn(
        "space-y-2",
        isLcStudent && "[&_[data-quiz-media]]:!mt-6 [&_[data-quiz-media]>div]:!my-0"
      ),
      children: [
        /* @__PURE__ */ jsx(QuizTypeBadge, { quizId, typeLabel, difficultyLevel, variant }),
        (() => {
          const polygonCounts = parsePolygonTitle(title);
          return polygonCounts ? /* @__PURE__ */ jsx(PolygonRenderer, { counts: polygonCounts }) : /* @__PURE__ */ jsx(
            "h3",
            {
              "data-quiz-title-text": true,
              className: cn(
                isLcStudent ? "text-[20px] font-semibold leading-[1.45] tracking-[-0.1px] text-lc-text-primary" : isAiqStudent ? "text-[22px] font-medium leading-normal text-lc-text-primary" : "text-2xl font-bold leading-relaxed text-gray-900",
                dimTitleText && "opacity-[0.05]"
              ),
              children: /* @__PURE__ */ jsx(KatexText, { text: title })
            }
          );
        })(),
        problem && /* @__PURE__ */ jsx("div", { "data-quiz-problem-text": true, className: cn(dimProblemText && "opacity-[0.05]"), children: problem }),
        /* @__PURE__ */ jsx(
          QuizMedia,
          {
            image,
            imageMobile,
            desmos,
            vars,
            className: cn(dimMedia && "opacity-[0.05]")
          }
        )
      ]
    }
  );
}
export {
  QuizHeader
};
//# sourceMappingURL=quiz-header.js.map
